import { render, staticRenderFns } from "./CustomLinkButton.vue?vue&type=template&id=00089402&scoped=true"
import script from "./CustomLinkButton.vue?vue&type=script&lang=js"
export * from "./CustomLinkButton.vue?vue&type=script&lang=js"
import style0 from "./CustomLinkButton.vue?vue&type=style&index=0&id=00089402&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00089402",
  null
  
)

export default component.exports